<div class="hb-card hb-card--fullbredde">
  <div [id]="idPrefix + id()" class="qlik" [style]="sizeStyle">
    <span class="hb-spinner hb-spinner--overliggende hb-spinner--tekst-justert" role="alert">
      <span class="hb-screenreader-only">Vennligst vent, Qlik-grafen laster.</span>
    </span>
    <span class="hb-spinner-tekst">Laster Qlik-graf...</span>
  </div>

  <footer class="hb-card-footer hb-card-utfallende--bunn">
    @if (visExcel()) {
      <button hb-button variant="SUBTLE" iconId="hb-spreadsheet" title="Eksporter til excel" (click)="saveAsExcel()">Excel</button>
    }
    <button
      hb-button
      variant="SUBTLE"
      [iconId]="visDatagrunnlagUtvidet ? 'remove' : 'book-open-text'"
      title="Vis datagrunnlag"
      (click)="visDatagrunnlagUtvidet = !visDatagrunnlagUtvidet"
    >
      Om nøkkeltall
    </button>
    @if (visDatagrunnlagUtvidet) {
      <div>
        <div class="hb-p--lg" id="info+id">
          <span class="hb-text--xs">{{ hentFilterListe() }}</span>
        </div>
      </div>
    }
  </footer>
</div>
